'use client';

import type { EventsResponseByBadge, PersonAllocation } from '@/app/models/providersResponse';
import { useListByPeriodAndPersonAndProviderQuery } from '@/app/services/eventsApi';
import formatterMonetaryValue from '@/app/utils/numberUtils';
import formatterPercentualValue from '@/app/utils/percentualUtils';
import { usePeriod } from '@/context/PeriodContext';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import { useState } from 'react';

const mainRowSx = {
  '& > *': { borderBottom: 'unset' },
  backgroundColor: 'grey.100',
  cursor: 'pointer',
};

const mainCellSx = {
  fontSize: 'body2.fontSize',
  backgroundColor: 'grey.50',
};

const subRowSx = {
  backgroundColor: 'background.paper',
};

const subCellSx = {
  fontSize: 'body2.fontSize',
  backgroundColor: 'background.paper',
  pl: 5,
  pr: 2,
  py: 1,
};

const categoryContainerSx = {
  display: 'flex',
};

const categoryTextSx = {
  mr: 7.5,
  fontSize: 'body2.fontSize',
};

const expenseGroupTextSx = {
  fontSize: 'body2.fontSize',
};

function EventsCollaboratorTable(props: { row: PersonAllocation }) {
  const { row } = props;
  const { selectedPeriod } = usePeriod();

  const { data } = useListByPeriodAndPersonAndProviderQuery({
    period: selectedPeriod?.date ?? '',
    badge: row.person.badge,
    code: row.provider.code,
  });

  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow sx={mainRowSx} onClick={() => setOpen(!open)}>
        <TableCell sx={mainCellSx}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {`${row.person.badge} - ${row.person.name}`}
        </TableCell>
        <TableCell sx={mainCellSx}>{`${formatterMonetaryValue(row.salaryValue)}`}</TableCell>
        <TableCell sx={mainCellSx} align="center">
          {`${formatterPercentualValue(row.percent)}`}
        </TableCell>
        <TableCell sx={mainCellSx} />
      </TableRow>

      {open &&
        data?.map((subRow: EventsResponseByBadge) => (
          <TableRow key={subRow.badge + subRow.value + subRow.code} sx={subRowSx}>
            <TableCell component="th" scope="row" sx={subCellSx}>
              <Box sx={categoryContainerSx}>
                <Typography
                  sx={expenseGroupTextSx}
                >{`${subRow.expenseGroup} - ${subRow.expenseCode} - ${subRow.expenseName}`}</Typography>
              </Box>
            </TableCell>
            <TableCell align="left" sx={{ ...subCellSx, pl: 2 }}>
              {`${formatterMonetaryValue(subRow.value)}`}
            </TableCell>
            <TableCell sx={{ ...subCellSx, pl: 2 }} />
            <TableCell sx={{ ...subCellSx, pl: 2 }} />
          </TableRow>
        ))}
    </>
  );
}

export default EventsCollaboratorTable;
